export const UserRoles = Object.freeze({
    COMMERICAL: "PACE.Commercial",
    IT_ADMIN: "PACE.ITAdmin",
    DISTRIBUTOR: "PACE.Distributor",
    values: {
        "PACE.Commercial": {
            title: "Commercial"
        },
        "PACE.ITAdmin": {
            title: "IT Admin"
        },
        "PACE.Distributor": {
            title: "Distributor"
        }
    }
});

